module.exports = __webpack_public_path__ + "5cc08210529fdb993c17e91bb88335c3.jpg";